import React from 'react';
import { motion } from 'framer-motion';
import { CalendarClockIcon, FilePenLineIcon, RefreshCwIcon, ScanSearchIcon, ShieldCheckIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
const modules = [{
  icon: ScanSearchIcon,
  number: '01',
  title: 'Scanner de Encuadre RG 5866',
  benefit: 'El atajo operativo.',
  description: 'Olvidate de leer la resolución mil veces. Un framework de detección rápida para filtrar toda tu cartera (Directores de SA, Gerentes de SRL, Profesionales) en minutos y sin errores de interpretación técnica.'
}, {
  icon: ShieldCheckIcon,
  number: '02',
  title: 'Protocolo de Blindaje y Notificación',
  benefit: 'Estructura de responsabilidad.',
  description: 'La RG 5866 delega una nueva carga en el cliente. Estos modelos de comunicación no solo notifican; dejan constancia legal de que tu estudio cumplió con el encuadre, protegiendo tu responsabilidad profesional.'
}, {
  icon: CalendarClockIcon,
  number: '03',
  title: 'Tablero de Control de Vencimientos 2026/2027',
  benefit: 'Tu hoja de ruta.',
  description: 'Mapa visual de la implementación gradual organizada por sectores: Aseguradoras (Septiembre), Entidades Financieras (Octubre), Tarjetas (Noviembre) y Servicios (2027). Sabé exactamente qué vencimiento sigue sin abrir el Boletín Oficial.'
}, {
  icon: FilePenLineIcon,
  number: '04',
  title: 'Kit de Documentación de Respaldo Editable',
  benefit: 'Identidad de tu estudio.',
  description: 'Plantillas en formato profesional (Word/Excel) listas para poner tu logo. Constancias de notificación y formularios de encuadre para que tu trabajo luzca ante el cliente como una consultoría de primer nivel.'
}, {
  icon: RefreshCwIcon,
  number: '05',
  title: 'Sistema de Actualización Recurrente',
  benefit: 'Tranquilidad total.',
  description: 'Si ARCA modifica un plazo, incorpora un nuevo sujeto o cambia un procedimiento en los próximos 12 meses, recibís la versión actualizada en tu mail sin pagar un peso más.'
}];
export function Solution() {
  return <section className="w-full bg-base" data-id="element-250" data-mp="1gkie08odo4dg">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-251" data-mp="1lh0h74427uno">
        <SectionReveal className="mx-auto max-w-4xl text-center" data-id="element-252" data-mp="1lffnththehre">
          <span className="inline-flex items-center rounded-full bg-blue px-4 py-1.5 text-xs font-medium uppercase tracking-badge text-white" data-id="element-253" data-mp="1qfadxj5fn3be">
            EstudioPack RG 5866™ · Sistema Operativo Premium
          </span>
          <h2 className="mt-5 text-2xl font-black leading-tight text-ink sm:text-3xl md:text-4xl" data-id="element-254" data-mp="xs7ix0zytapw">
            Un Sistema Diseñado para Dejar de Perder Horas en ARCA y Estructurar
            tu Estudio.
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-ink-soft" data-id="element-255" data-mp="17jk4xbz316o0">
            Cinco módulos operativos para encuadrar, documentar y controlar cada
            etapa sin volver a empezar desde cero.
          </p>
        </SectionReveal>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-256" data-mp="7gm2w8trvokw">
          {modules.map((module, index) => {
          const Icon = module.icon;
          const isLast = index === modules.length - 1;
          return <motion.article key={module.number} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.45,
            delay: index * 0.08
          }} className={`rounded-2xl border border-alt bg-base p-6 shadow-sm sm:p-7 ${isLast ? 'md:col-span-2 md:mx-auto md:w-full md:max-w-[calc(50%-0.625rem)]' : ''}`} data-id="element-257" data-mp="3tr89uh5j80nb" data-mpi={index}>
                <div className="flex items-center justify-between gap-4" data-id="element-258" data-mp="2wzo56snf5b4r">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue/10 text-blue" data-id="element-259" data-mp="3lqtun4bgg80l">
                    <Icon className="h-5 w-5" strokeWidth={2.2} data-id="element-260" data-mp="3qo3u7csk6025" />
                  </span>
                  <span className="text-sm font-black text-accent" data-id="element-261" data-mp="3cwfhb7ahj7k4">
                    MÓDULO {module.number}
                  </span>
                </div>
                <h3 className="mt-5 text-lg font-black leading-snug text-ink" data-id="element-262" data-mp="32zaq2t1s8lwg">
                  {module.title}
                </h3>
                <p className="mt-2 font-bold text-accent" data-id="element-263" data-mp="37z5ln9wi5znu">{module.benefit}</p>
                <p className="mt-3 text-[15px] leading-relaxed text-ink-soft" data-id="element-264" data-mp="2tyuu04ndch1m">
                  {module.description}
                </p>
              </motion.article>;
        })}
        </div>

        <SectionReveal delay={0.12} data-id="element-265" data-mp="s6q4eztcdvu2">
          <aside className="mt-8 rounded-2xl border-2 border-dashed border-accent/45 bg-accent/5 p-6 sm:p-7" data-id="element-266" data-mp="s7rdiyqss895">
            <p className="text-lg font-black leading-snug text-ink" data-id="element-267" data-mp="w6gz3elzow3v">
              🎁 REGALO: Asistente de Consultas Rápidas (WhatsApp).
            </p>
            <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-268" data-mp="2cq1xgtk4a2bw">
              Las 12 respuestas técnicas definitivas listas para copiar y pegar.
              Dejá de responder las mismas dudas a tus clientes fuera de
              horario.
            </p>
          </aside>
        </SectionReveal>
      </div>
    </section>;
}